export class AuthenticationError extends Error {}
export class InvalidLoginStrategyError extends AuthenticationError {
  constructor(message?: string) {
    super(message ?? 'InvalidLoginStrategy');
  }
}

export class UseBeforeInitializeError extends AuthenticationError {
  constructor(message?: string) {
    super(message ?? 'Authenticator must be initialized before this method can be called');
  }
}
